import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, Suspense, useState } from "react";
import SideBarAdmin from "@components/Admin/SideBar/index";
import ErrorPopup from "@components/Error-PopUp";

const AdminLayout = () => {
  const navigate = useNavigate();
  const [isPopupVisible, setPopupVisible] = useState(false);

  const hidePopup = () => {
    setPopupVisible(false);
    navigate("/admin", { replace: true });
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      setPopupVisible(true);
    }
  }, []);

  return (
    <>
      {isPopupVisible && (
        <ErrorPopup
          title="Sesión Expirada"
          message="Tu sesión ha expirado. Inicia sesión nuevamente."
          onClose={hidePopup}
        />
      )}
      <div style={{ backgroundColor: "#F5F5F5", height: "100vh", display: "flex" }}>
        <div style={{ position: "relative" }}>
          <div style={{ position: "fixed", zIndex: 1 }}>
            <SideBarAdmin />
            <Suspense fallback={<div style={{ width: "78%", height: "100vh" }} />}>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLayout;
